const URL = {
  build: (...props: any[]) =>
    ['/', [...props].join('/')].join('').replace(/\/\//g, '/')
}

export default URL
